// services/atualizarApartamento.ts
// --------------------- Import Global ---------------------
import axios from "axios";
import Globais, { validateToken } from "../components/Globais";

export const atualizarGrupo = async (valuesGrupo: any) => {
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/grupo`;
    try {
      const response = await axios.put(URL, valuesGrupo, {
        headers: { Authorization: Token.AuthStr },
      });
      if (response && response.data) {
        return response.data;
      }
    } catch (error) {
      console.error(error);
    }
  }
};
